import React, { Component } from "react";
import HeadBar from "./common/HeadBar";
import FootBar from "./common/FootBar";
import proof from "../image/proof-of-address.jpg";
import "../style/proof.scss";
import { routePage } from "../utils/routePage";
import safeParse from "../utils/SafeParseLocalstrorage";
import { lang } from "../utils/lang";
import getAd from "../utils/GetAd";

class Proof extends Component {
  constructor(props) {
    super(props);
    this.state = {
      animation: false,
      ad: getAd(),
    };
  }

  componentDidMount() {
    let flag = setInterval(() => {
      clearInterval(flag);
      this.setState({
        animation: true,
      });
    }, 2000);
  }

  render() {
    const { animation, ad } = this.state;
    let { history, location } = this.props;
    return (
      <React.Fragment>
        <div className={`proof-page ${animation ? "animation-show" : ""}`}>
          <HeadBar {...this.props} />
          <div className="proof-box">
            <h1>Address Verification</h1>
            <h2>
              To verify your address, please upload a document that clearly
              shows your current address, such as a bank statement or a utility
              bill (gas, electricity, water, or telephone).
            </h2>
            <div className="gif-box">
              <img src={proof} alt="" />
            </div>
            <div
              className="btn"
              onClick={() => routePage(history, ad, "/proofInfo")}
            >
              {lang.next}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Proof;
